import axios from 'axios';
import getApiBaseUrl from '../GetServer';

interface UserData {
    IdUser: number;
    UserName: string;
    Email: string;
}

interface PasswordData {
    IdUser: number;
    CurrentPassword: string;
    NewPassword: string;
}

interface BackendResponse {
    status: number;
    message: string;
}

/**
 * Servicio para actualizar los datos del usuario (nombre y email).
 */
export const updateUserData = async (data: UserData): Promise<BackendResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/edit-user`;

        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<BackendResponse>(
            endpoint,
            {
                IdUser: data.IdUser,
                UserName: data.UserName,
                Email: data.Email
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.data.status !== 200) {
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            // Si el error viene del backend, devolver el mensaje específico
            throw new Error(error.response.data.message);
        }
        console.error('Error al actualizar datos del usuario:', error);
        throw error;
    }
};

/**
 * Servicio para cambiar la contraseña del usuario.
 */
export const changeUserPassword = async (data: PasswordData): Promise<BackendResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/edit-user`;

        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<BackendResponse>(
            endpoint,
            {
                IdUser: data.IdUser,
                CurrentPassword: data.CurrentPassword,
                NewPassword: data.NewPassword
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.data.status !== 200) {
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        console.error('Error al cambiar la contraseña:', error);
        throw error;
    }
};